import { createSelector } from 'reselect'
import { find } from 'lodash'

export const getCurrentProject = state => state.account.currentProject
export const isProjectLoading = state => state.account.currentProject.loading

export const getProjectSelector = createSelector(
	[
		state => state.account,
		(state, props) => props.match ? props.match.params : null,
		(state, props) => props.location ? props.location.pathname : null
	],
	(accountState, matchParams, pathname) => {
		let project = null
	
		if(accountState.entities && accountState.entities.projects){
			if(accountState.currentProjectId){
				project = accountState.entities.projects[accountState.currentProjectId]
			}
	
			let slug = matchParams.project_slug ? matchParams.project_slug : null
			
			if(!slug && pathname){
				const pathSlices = pathname.split('/')

				let prevPathSlice = null
				pathSlices.forEach(slice => {
					if(prevPathSlice && prevPathSlice == 'projects'){
						slug = slice
					}

					prevPathSlice = slice
				})
			}
	
			if(slug && (!project || project.slug !== slug)){
				const actualProject = find(accountState.entities.projects, project => {
					return project.slug === matchParams.project_slug
				})
	
				if(actualProject){
					project = actualProject
				}
			}
        }
	
		return (project && project.name) ? project : null
	}
)


// WEBPACK FOOTER //
// ./src/state/selectors/projectSelectors.jsx